import { CurecallBadge, CurecallTag, ECurecallBadgeColor } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'

import { EVariableType } from 'src/types/variable'
import type { TPatientConversationDetail } from '../human-review-requests.type'

type TConversationDetailProps = {
  conversation: TPatientConversationDetail
  missingDocumentVariableIds?: number[]
  // Whether the card has a missing document problem: its unanswered documents are all missing
  hasMissingDocument?: boolean
}

export const ConversationDetail = ({
  conversation,
  missingDocumentVariableIds = [],
  hasMissingDocument = false,
}: TConversationDetailProps) => {
  const { t } = useTranslation()

  return (
    <>
      {conversation.questions.map((question) => (
        <div
          key={question.variableId}
          className="c-flex c-items-center c-justify-between c-px-4 c-py-3 c-gap-4 c-bg-white c-border c-border-grey-200 c-rounded-lg"
        >
          <span className="c-text-sm c-font-medium">{question.variableLabel}</span>
          {question.patientAnswer !== null ? (
            question.variableType === EVariableType.MEDIA ? (
              <CurecallTag status="SUCCESS">
                {t('components.patient-documents-modal.status-received')}
              </CurecallTag>
            ) : (
              <CurecallBadge color={ECurecallBadgeColor.SMOOTH_PRIMARY}>
                {question.patientAnswer}
              </CurecallBadge>
            )
          ) : missingDocumentVariableIds.includes(question.variableId) ||
            (hasMissingDocument && question.variableType === EVariableType.MEDIA) ? (
            <CurecallTag status="WARNING">
              {t('pages.dashboard.human-review-requests.problems.labels.missing-document-short')}
            </CurecallTag>
          ) : (
            <span className="c-text-sm c-text-grey-700 c-italic">
              {t('pages.dashboard.human-review-requests.problems.labels.no-response')}
            </span>
          )}
        </div>
      ))}
    </>
  )
}
